import { apiClientWithRefreshToken } from "@/api/apiClient";

async function ExportMobilization({
    limit,
    filter,
}: {
    filter?: Record<string, string>;
    limit?: number;
}) {
    return apiClientWithRefreshToken({
        url: "/mobilizations/export",
        method: "GET",
        responseType: "blob",
        params: {
            ...filter,
            limit: limit || 20,
        },
    });
}

export default ExportMobilization;
